import { Theme } from '@mirai/ui';

export const getStyle = () => {
  const { borderRadius, inputFont, content } = Theme.get();

  return `
    .card-field-wrapper label,
    .holdername-field-wrapper label {
      font-family: ${inputFont};
      color: ${content};
    }

    .card-field-wrapper input,
    .holdername-field-wrapper input {
      border-radius: ${borderRadius}px;
      font-family: ${inputFont};
      color: ${content};
    }

    #cvv-primary {
      margin-right: ${borderRadius}px;
    }
    `;
};
